import { UseGqlMutationCallbacks, useMutationOptionsWithInvalidation } from '@alice-financial/api'
import { useMutation } from '@tanstack/react-query'
import { useMutationNotifier } from '../../../notifications/useMutationNotifier'
import { useAdminUserProfileQuery } from '../queries/adminUserProfile_gen'
import {
  UpdateNotificationPreferencesMutation,
  UpdateNotificationPreferencesMutationVariables,
  useUpdateNotificationPreferencesMutation,
} from './updateNotificationPreferences_gen'

export { NotificationChannel, NotificationType } from '../../generated.types'
export type { NotificationPreference } from '../../generated.types'

type UseUpdateNotificationPreferencesOptions = UseGqlMutationCallbacks<
  UpdateNotificationPreferencesMutation,
  Pick<UpdateNotificationPreferencesMutationVariables, 'notificationPreferences'>
>
export const useUpdateNotificationPreferences = (
  userId: number,
  mutationOptions?: UseUpdateNotificationPreferencesOptions
) => {
  const optionsWithNotifs = useMutationNotifier({}, mutationOptions)
  const optionsWithInvalidation = useMutationOptionsWithInvalidation(optionsWithNotifs, [
    useAdminUserProfileQuery.getKey(),
  ])
  const { mutateAsync } = useUpdateNotificationPreferencesMutation()
  return useMutation(
    ({ notificationPreferences }) => mutateAsync({ userId, notificationPreferences }),
    optionsWithInvalidation
  )
}
